import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

import wageAdvanceComponent from './wageAdvance.component';
import WageAdvanceService from './wageAdvance.service';
import WageAdvanceHelper from './wageAdvance.helper';
import WageAdvanceInfo from './wageAdvanceInfo/wageAdvanceInfo';
import WageAdvanceForm from './wageAdvanceForm/wageAdvanceForm';
import WageAdvanceList from './wageAdvanceList/wageAdvanceList';
import WageAdvanceResume from './wageAdvanceResume/wageAdvanceResume';
import WageAdvanceModal from './wageAdvanceModal/wageAdvanceModal';

let wageAdvanceModule = angular.module('wageAdvance', [
  uiRouter,
  WageAdvanceInfo,
  WageAdvanceForm,
  WageAdvanceList,
  WageAdvanceResume,
  WageAdvanceModal,
])

  .component('wageAdvance', wageAdvanceComponent)

  .service('wageAdvanceService', WageAdvanceService)
  .service('wageAdvanceHelper', WageAdvanceHelper)

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.WAGE_ADVANCE, {
        url: ROUTES.LOANS.WAGE_ADVANCE,
        component: 'wageAdvance',
        params: {
          stateAccess: null,
        },
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isWageInProcess()
        }
      });
  })

  .name;

export default wageAdvanceModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvance.js